import { render, staticRenderFns } from "./SidePreview.vue?vue&type=template&id=58750f7a&"
import script from "./SidePreview.vue?vue&type=script&lang=js&"
export * from "./SidePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports